import React, {Component} from 'react';
import {gpn} from "../GPN"
import Field from "./sections/MUI/Field";
import Button from "./sections/MUI/Button";
import axios from "axios";
import config from "../config";
import {toast} from "react-toastify";
import Icon from "./sections/MUI/Icon";

class Plans extends Component {

    state = {
        plans: [],

        title: "",
        max: "",
        month: ""
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getPlans();
    }


    getPlans() {
        this.req({action: "list"})
            .then(r => {
                let list = r ? r : [];
                list = list ? list : [];
                this.setState({
                    plans: list
                });
            });
    }

    save() {
        let {title, max, month} = this.state;
        title = title.toString().trim();
        max = max.toString().trim().replace(/,/g, "").trim();
        max = max !== "" ? Number(max) : 0;
        month = month.toString().trim() !== "" ? Number(month.toString().trim()) : 12;

        if (title !== "" && max !== 0) {
            toast.info("در حال ثبت ...", {autoClose: 1000});
            this.req({action: "create", title, max: max.toString().trim(), month: month.toString()})
                .then(r => {
                    toast.success("با موفقیت ثبت شد.", {autoClose: 1000});
                    this.setState({
                        title: "",
                        max: "",
                        month: ""
                    });

                    this.getPlans();
                });
        } else {
            toast.error("فیلد های خواسته شده را تکمیل کنید!");
        }
    }

    edit(index = 0) {
        let {plans} = this.state;
        let {id, title, max, month} = plans[index];
        id = id.toString().trim();
        title = title.toString().trim();
        max = max.toString().trim().replace(/,/g, "").trim();
        max = max !== "" ? Number(max) : 0;
        month = month.toString().trim();
        month = month !== "" ? Number(month) : 12;

        if (id !== "" && title !== "" && max !== 0) {
            toast.info("در حال ویرایش ...")
            this.req({action: "edit", id, title, max: max.toString(), month: month.toString()})
                .then(r => {
                    toast.success("با موفقیت ویرایش شد.");
                    this.getPlans();
                });
        } else {
            toast.error("فیلد ها را تکمیل کنید!");
        }
    }

    delete(index = -1) {
        if (index !== -1) {
            let {plans} = this.state;
            let {id} = plans[index];
            id = id.toString().trim();
            toast.info("در حال حذف ...")
            this.req({action: "delete", id})
                .then(r => {
                    toast.success("با موفقیت حذف شد!");
                    this.getPlans();
                });
        }
    }

    req(params = null) {
        let paramsUrl = new URLSearchParams(params ? params : {action: "list"});
        return new Promise(resolve => {
            axios.post(`${config.api}/plan?token=${config.token}`, paramsUrl)
                .then(r => {
                    return resolve(r.data);
                })
                .catch(err => {
                    toast.error("خطا!");
                    console.error(err);
                    return resolve(null);
                });
        })
    }

    handleInputChange(name, value, index = 0) {
        let {plans} = this.state;
        plans[index][name] = value;
        this.setState({plans});
    }

    render() {
        let {plans, title, max, month} = this.state;
        return (
            <div className="plans">
                <div className="new">
                    <div className="row">
                        <div className="col-md-4">
                            <Field name="title"
                                   value={title}
                                   onChange={(name, value) => this.setState({[name]: value})}
                                   label="نام طرح"
                                   maxLength={500}/>
                        </div>
                        <div className="col-md-4">
                            <Field name="max"
                                   value={max}
                                   typePrice
                                   style={{direction: "ltr"}}
                                   onChange={(name, value) => this.setState({[name]: value})}
                                   label="سقف وام (تومان)"
                                   maxLength={25}/>
                        </div>
                        <div className="col-md-2">
                            <Field name="month"
                                   value={month}
                                   type="number"
                                   style={{direction: "ltr"}}
                                   onChange={(name, value) => this.setState({[name]: value})}
                                   label="بازپرداخت"
                                   maxLength={5}/>
                        </div>
                        <div className="col-md-2"
                             style={{marginTop: 8}}>
                            <Button submit={false} icon="check" onClick={() => this.save()}>ثبت کردن</Button>
                        </div>
                    </div>
                </div>
                <br/><br/>
                <div className="list">
                    {
                        plans.map((p, i) =>
                            <article key={"plan" + i}>
                                <div className="row">
                                    <div className="col">
                                        <Field name="title"
                                               value={p.title}
                                               onChange={(name, value) => this.handleInputChange(name, value, i)}
                                               label="نام طرح"
                                               maxLength={500}/>
                                    </div>
                                    <div className="col">
                                        <Field name="max"
                                               typePrice
                                               style={{direction: "ltr"}}
                                               value={p.max.toString()}
                                               onChange={(name, value) => this.handleInputChange(name, value.toString(), i)}
                                               label="سقف وام (تومان)"
                                               maxLength={25}/>
                                    </div>
                                    <div className="col">
                                        <Field name="month"
                                               type="number"
                                               style={{direction: "ltr"}}
                                               value={p.month ? p.month.toString() : ""}
                                               onChange={(name, value) => this.handleInputChange(name, value.toString(), i)}
                                               label="بازپرداخت"
                                               maxLength={25}/>
                                    </div>
                                    <div className="col-auto">
                                        <Icon i="edit" className="edit-icon" onClick={() => this.edit(i)}/>
                                        <Icon i="trash" className="delete-icon" onDoubleClick={() => this.delete(i)}/>
                                    </div>
                                </div>
                            </article>
                        )
                    }
                </div>
            </div>
        );
    }
}

export default gpn(Plans);